import store from "../store";
/*import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../helpers/PGSHelper.js';*/

export default class Concierges {
  static typeSearch = "local"; //online || local
  static rules = {
    requerido: [(value) => !!value || "El campo es obligatorio"],
  };

  constructor(data = null) {
    this.htl = data?.htl ? data.htl : { id: null, nm: "" };
    this.nom = data?.nom ? data.nom : "";
    this.Tenant = data?.Tenant
      ? data.Tenant
      : store.getters.getFirebaseApp.tenant;
    this.Id = data?.id ? data.id : null;
    this.dlat = data?.dlat ? data?.dlat : null;
    this.cms = data?.cms ? data.cms : { tp: "%", vl: 10 };
    this.fdp = data?.fdp ? data.fdp : [];
    this.mdc = data?.mdc ? data.mdc : [];
    /*this.Cuenta =  data?.Cuenta ? data.Cuenta: null;
    this.Activo = data?.Activo ? data.Activo:null;*/
  }

  static getRules() {
    return this.rules;
  }

  static getPropertyModel() {
    return this;
  }
}
